import { render, staticRenderFns } from "./SectionCatalogueCTA.vue?vue&type=template&id=76aeb765&"
import script from "./SectionCatalogueCTA.vue?vue&type=script&lang=js&"
export * from "./SectionCatalogueCTA.vue?vue&type=script&lang=js&"
import style0 from "./SectionCatalogueCTA.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports